
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

const SubmitToolDialog = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();

    // Listen for auth state changes
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      console.log("Auth state changed:", event, !!session);
      setIsAuthenticated(!!session);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const checkAuthStatus = async () => {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error("Error checking auth status:", error);
      }
      console.log("Auth session check:", !!session);
      setIsAuthenticated(!!session);
    } catch (error) {
      console.error('Error checking auth status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitClick = () => {
    if (isAuthenticated) {
      navigate("/submit-app");
    } else {
      toast({
        title: "Authentication Required",
        description: "Please sign in to submit an app.",
      });
      navigate("/auth");
    }
  };

  return (
    <Button 
      variant="default" 
      className="w-full" 
      onClick={handleSubmitClick}
      disabled={isLoading}
    >
      {isLoading ? "Loading..." : "Submit App"}
    </Button>
  );
};

export default SubmitToolDialog;
